import { cx } from "@suse-o11y/class-variance";
import { min } from "@suse-o11y/min";
import React from "react";

import { Truncated } from "~/components/truncated";

export interface ChartSeriesLabelProps {
	className?: string;

	children: number | string;
	fontSize: number;
}

const MAX_FONT_SIZE = 32;

export const ChartSeriesLabel: React.FC<ChartSeriesLabelProps> = ({ className, children, fontSize }) => (
	<div className={cx("flex w-full items-center justify-center font-text text-grey-800 leading-tight", className)}>
		<Truncated style={{ fontSize: min(fontSize, MAX_FONT_SIZE) }}>{children}</Truncated>
	</div>
);
